<template>
  <div>
    <el-popover placement="top" width="400" trigger="manual" v-model="skuImportPopover">
      <div slot="reference" class="operation_btn_box">
        <div class="operate_btn operate_btn_white" @click="clearSkuList">全部删除</div>
        <div class="operate_btn operate_btn_red" @click="skuImportPopover = !skuImportPopover">批量添加</div>
      </div>
      <div v-loading="loading">
        <el-row :gutter="10" class="flex-center">
          <el-col :span="6" class="font-weight-700">数据文件</el-col>
          <el-col :span="8">
            <FileUpload :upload-param="{ filePath: 'temp' }" :save-item="fileList" show-type="text"
              @uploaded="getExecTemplateId" @removed="clearExecTemplateId">
              <el-button size="small" type="primary" class="upload-button">点击上传</el-button>
            </FileUpload>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6" class="font-weight-700">模板文件</el-col>
          <el-col :span="6">
            <div class="button-text" @click="downloadSkuTemplate('skuTemplate')">下载SKU模板</div>
          </el-col>
          <el-col :span="6">
            <div class="button-text" @click="downloadSkuTemplate('exportSKUData')">下载SKU信息</div>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">&nbsp;</el-col>
          <el-col :span="6">
            <div class="operate_btn operate_btn_pink" @click="skuImportPopover = false" style="margin: 0px;">关闭</div>
          </el-col>
          <el-col :span="6">
            <div class="operate_btn operate_btn_red" @click="confirmUpload" style="margin: 0px;">确认上传</div>
          </el-col>
        </el-row>
      </div>
    </el-popover>
    <el-dialog title="不合格数据" :visible.sync="errorDialog" width="50%" center>
      <el-table :data="errorList" tooltip-effect="dark" style="width: 100%" :show-header='false'>
        <el-table-column align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row }}</template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import FileUpload from './file-upload'
import gameplanApi from '@/api/gameplan'
export default {
  components: {
    FileUpload
  },
  data() {
    return {
      fileList: [],
      skuImportPopover: false,
      errorDialog: false,
      errorList: [],
      skuData: [],
      loading: false,
      dataFileId:''
    }
  },
  computed: {},
  methods: {
    // 确认上传
    async confirmUpload() {
      if(!this.dataFileId) return this.$message.error("请上传文件")
      let params = {
        "fileId": this.dataFileId,
      }
      this.loading = true
      const { data } = await gameplanApi.importSKUData(params)
      if (data.resultCode === '0') {
        const { errorSKU, successSKU } = data.resultData
        if (errorSKU && errorSKU.length) {
          this.errorDialog = true
          this.errorList = errorSKU
        }
        if (successSKU && successSKU.length) {
          this.skuData = successSKU
          const skuData = this.skuData.map(item => {
            return {
              skuCode: item.skuCode,
              skuName: item.skuName,
            }
          })
          this.$message.success("批量添加成功")
          this.$emit('on-uploaded', skuData)
        }
      }
      this.loading = false
      this.skuImportPopover = false
    },
    // 下载SKU模板/SKU信息
    async downloadSkuTemplate(type) {
      let api = ''
      if (type === 'skuTemplate') {
        api = 'downloadSkuTemplate'
      } else if (type === 'exportSKUData') {
        api = 'exportSKUData'
      }
      const res = await gameplanApi[api]()
      let fileName = ''
      let fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      let matches = fileNameRegex.exec(res.headers['content-disposition'])
      if (matches != null && matches[1]) {
        fileName = matches[1].replace(/['"]/g, '')
      }
      const url = window.URL.createObjectURL(res.data);
      const link = document.createElement('a');
      link.href = url;
      fileName = decodeURI(fileName)
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 全部删除
    clearSkuList() {
      this.$emit('on-clear')
    },
    getExecTemplateId(file) {
      this.dataFileId = file.fileId
    },
    // 删除文件
    clearExecTemplateId(file) {
      this.dataFileId = ''
    },
  },
}
</script>
<style lang='scss' scoped>
.operation_btn_box {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 0px 0 10px 0;
}

.operate_btn {
  display: inline-block;
  white-space: nowrap;
  text-align: center;
  padding: 5px 10px;
  border-radius: 4px;
  margin: -5px 0 0 10px;
  width: 65px;
  cursor: pointer;
}

.operate_btn_red {
  color: white;
  background-color: rgb(214, 0, 0);
  border: 1px solid rgb(214, 0, 0);
}

.operate_btn_white {
  color: rgb(214, 0, 0);
  background-color: white;
  border: 1px solid rgb(214, 0, 0);
}

.operate_btn_pink {
  color: rgb(214, 0, 0);
  background-color: #fff4f4;
  border: solid 1px #fd9e97;
}

::v-deep .el-dialog__header {
  border-bottom: 0px;
  font-weight: normal;
}

::v-deep .el-row {
  padding-left: 10px;
  margin: 20px 0px 10px 0px;

}

.button-text {
  cursor: pointer;
  color: #0075FF;

  &:hover {
    opacity: 0.8;
  }
}

.upload-button {
  background-color: #0075FF;
}</style>
